import { Pagination as MUIPagination, PaginationProps } from '@mui/material';
import React from 'react';

const Pagination = (props: PaginationProps) => {
    return <MUIPagination {...props} />;
};

export default Pagination;
